import { api } from '@services';

interface IRequest {
  id: string;
}

const showDefaultStatus = async ({ id }: IRequest): Promise<string> => {
  const { data: defaultStatus } = await api.get<string>(
    `/studios/${id}/defaultStatus`,
  );

  return defaultStatus;
};

export { showDefaultStatus };
